// extracted by mini-css-extract-plugin
export var backgroundColor = "#141821";
export var borderRadius = ".15rem";
export var headerIcon = "appearances-module--header-icon--73f03";
export var maxModalWidth = "48em";
export var modalBackgroundColor = "rgba(20,24,33,.75)";
export var note = "appearances-module--note--cb270";